import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-black text-white px-4 sm:px-6 md:px-8 py-12 space-y-12">
      {/* Row 1 */}
      <div className="max-w-xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 justify-items-center text-center md:text-left">
        {/* Column 1 */}
        <div className="space-y-4 w-full">
          <h3 className="text-xl font-semibold">Links</h3>
          <ul className="space-y-2">
            <li>
              <a href="https://t.me/nadstradebot" target="_blank" rel="noopener noreferrer" className="underline">
                Telegram
              </a>
            </li>
            <li>
              <a href="https://x.com/NadsTradingBot" target="_blank" rel="noopener noreferrer" className="underline">
                X (Twitter)
              </a>
            </li>
            <li>
              <a href="https://example.com/docs" target="_blank" rel="noopener noreferrer" className="underline">
                Docs
              </a>
            </li>
          </ul>
        </div>

        {/* Column 2 */}
        <div className="space-y-4 w-full">
          <h3 className="text-xl font-semibold">Contact</h3>
          <p>Need help or partnerships?</p>
          <p>Reach the NTB team:</p>
          <ul className="space-y-2">
            <li>Email</li>
            <li>Telegram Support</li>
            <li>
              X / Twitter
            </li>
          </ul>
          <p>We respond fast because in DeFi, time is money.</p>
        </div>
      </div>

      {/* Row 2 */}
      <div className="text-center space-y-2">
        <h3 className="text-2xl lg:text-4xl font-semibold text-white/50">
          Ready to Trade at Monad Speed?
        </h3>
        <p>The bot’s live. The chain’s ready.</p>
      </div>

      {/* Row 3 */}
      <div className="text-center text-gray-400">
        Built for the trenches. Powered by MonadScore. © {currentYear} NTB. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;